import { takeLatest, call, put } from 'redux-saga/effects';
import memberAdminApi from 'api/employee/memberAdminApi';
import memberAdminNoSessionApi from 'api/employee/memberAdminNoSessionApi';
import supportApi from 'api/others/supportApi';
import empSearchApi from 'api/employee/empSearchApi';
import * as employeeInformationActions from 'redux/ducks/personalInformation/employeeInformationDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* getReadEmployeeInfo() {
  try {
    const response = yield call(memberAdminApi.getReadEmployeeInfo);
    yield put(employeeInformationActions.getReadEmployeeInfoSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* modifyEmployeeInfo({ payload }) {
  try {
    const response = yield call(memberAdminApi.modifyEmployeeInfo, payload);
    yield put(employeeInformationActions.modifyEmployeeInfoSuccess(response));
  } catch (error) {
    if (error.errorCode === 'EM714') {
      yield put(alertActions.open({ message: [error.errorMessage] }));
    } else {
      yield put(alertActions.open({ message: [error.errorCode] }));
    }
  }
}

export function* getSupportList({ payload }) {
  try {
    const response = yield call(supportApi.getSupportList, payload);
    yield put(employeeInformationActions.getSupportListSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getCountryList() {
  try {
    const response = yield call(memberAdminNoSessionApi.getCountryList);
    yield put(employeeInformationActions.getCountryListSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}
export function* getTermsContentList({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getTermsContentList, payload);
    yield put(employeeInformationActions.getTermsContentListSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getTermsAgreementList() {
  try {
    const response = yield call(memberAdminApi.getTermAgreementList);
    yield put(employeeInformationActions.getTermsAgreementListSuccess(response));
  } catch (error) {
    yield put(employeeInformationActions.getTermsAgreementListFail());
  }
}

export function* getTermsVersion({ payload }) {
  try {
    const response = yield call(memberAdminApi.getTermsVersion, payload);
    yield put(employeeInformationActions.getTermsVersionSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getTermsContents({ payload }) {
  try {
    const response = yield call(memberAdminApi.getTermsContents, payload);
    yield put(employeeInformationActions.getTermsContentsSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getServiceList() {
  try {
    const response = yield call(empSearchApi.getUserInfoWithParam, ['SERVICECODE']);
    yield put(employeeInformationActions.getServiceListSuccess(response));
  } catch (error) {
    yield put(employeeInformationActions.getServiceListFail());
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getCookieSavedYn() {
  try {
    const response = yield call(empSearchApi.getUserInfoWithParam, ['COOKIESAVEDYN']);
    yield put(employeeInformationActions.getCookieSavedYnSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getMeetingDomain() {
  try {
    const response = yield call(empSearchApi.getMeetingDomain);
    yield put(employeeInformationActions.getMeetingDomainSuccess(response));
  } catch (error) {
    yield put(employeeInformationActions.getMeetingDomainFail());
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getDriveDomain({ payload }) {
  try {
    const response = yield call(empSearchApi.getDriveDomain, payload);
    yield put(employeeInformationActions.getDriveDomainSuccess(response));
  } catch (error) {
    yield put(employeeInformationActions.getDriveDomainFail());
  }
}

export function* getCompanyPolicy({ payload }) {
  try {
    const response = yield call(memberAdminApi.getCompanyPolicy, payload);
    yield put(employeeInformationActions.getCompanyPolicySuccess(response));
  } catch (err) {
    yield put(employeeInformationActions.getCompanyPolicyFail());
  }
}

export default function* employeeInformationSaga() {
  yield takeLatest(employeeInformationActions.getReadEmployeeInfo, getReadEmployeeInfo);
  yield takeLatest(employeeInformationActions.modifyEmployeeInfo, modifyEmployeeInfo);
  yield takeLatest(employeeInformationActions.getSupportList, getSupportList);
  yield takeLatest(employeeInformationActions.getCountryList, getCountryList);
  yield takeLatest(employeeInformationActions.getTermsContentList, getTermsContentList);
  yield takeLatest(employeeInformationActions.getTermsAgreementList, getTermsAgreementList);
  yield takeLatest(employeeInformationActions.getTermsVersion, getTermsVersion);
  yield takeLatest(employeeInformationActions.getTermsContents, getTermsContents);
  yield takeLatest(employeeInformationActions.getServiceList, getServiceList);
  yield takeLatest(employeeInformationActions.getCookieSavedYn, getCookieSavedYn);
  yield takeLatest(employeeInformationActions.getMeetingDomain, getMeetingDomain);
  yield takeLatest(employeeInformationActions.getDriveDomain, getDriveDomain);
  yield takeLatest(employeeInformationActions.getCompanyPolicy, getCompanyPolicy);
}
